// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type { BaseResponseListAsrSelectValueResponse } from '../../../../types';

/**
 * 获取当前租户可以选择的多语言
 *
 * @export
 * @tags asr-filter-config-controller
 * @link [GET] /asr-filter-config/asr/language/self
 */
export function getAsrFilterConfigAsrLanguageSelf(): Promise<BaseResponseListAsrSelectValueResponse>;
export function getAsrFilterConfigAsrLanguageSelf(
    options: ApiOptions<never, never>
): Promise<BaseResponseListAsrSelectValueResponse>;
export function getAsrFilterConfigAsrLanguageSelf(
    options?: ApiOptions<never, never>
): Promise<BaseResponseListAsrSelectValueResponse> {
    return request<never, never, never>('/asr-filter-config/asr/language/self', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAsrFilterConfigAsrLanguageSelf',
    });
}

export const meta = [
    {
        tags: ['asr-filter-config-controller'],
        path: '/asr-filter-config/asr/language/self',
        method: 'get',
    },
];
